<template lang="pug">
    nav#navegacao
        ul
            li(v-for="item, index in menu", @click="scrollTo(item.hash, offsetTop)", :class="{ ativo: ativo == item.hash }") 
                SvgIcon(:data="item.icone")
                span {{ item.titulo }} 
            //- li(@click="scrollTo('#inscricao', offsetTop)") 
            //-     SvgIcon(data="@svgs/curso/certificate.svg")
            //-     span Inscreva-se
</template>

<script>
export default {
    name: "section-navegacao",
    props: {
        itensMenu: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            offsetTop: window.innerWidth > 768 ? -275 : -325,
            ativo: '#apresentacao',
        }
    },
    computed: {
        menu() {
            let items = [{
                hash: '#apresentacao',
                titulo: 'Apresentação',
                icone: require('@svgs/curso/pen.svg'),
            }]
            return items.concat(this.itensMenu)
        }
    },
    mounted() {
        window.addEventListener('scroll', this.onScroll)
    },
    methods: {
        scrollTo(target, offset = 0) {
            const element = document.querySelector(target)
            if (element) {
                window.scrollTo({
                    top: element.offsetTop - offset,
                    left: 0,
                    behavior: 'smooth'
                })
            }
        },
        onScroll() {
            let scroll = window.scrollY
            this.menu.forEach(item => {
                let el = document.querySelector(item.hash)
                if (el.offsetTop < scroll + this.offsetTop)
                    this.ativo = item.hash
            })
        },
    },
    destroyed() {
        window.removeEventListener('scroll', this.onScroll)
    },
}
</script>

<style lang="stylus" scoped src="./Navegacao.styl"></style>